<template>
    <v-dialog v-model="mostrar" persistent max-width="80vw" scrollable>
		<v-card :loading="loading">
            <div ref="cv">
            </div>
			<v-toolbar flat :color="cor ? 'secondary' : ''" dark>
                <v-toolbar-title dark>Novo Atendimento</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
				    <!-- <v-btn text dark @click="salvar">mostrar</v-btn> -->
                    <v-btn text dark :disabled="desativarVoltar" @click="voltarEtapa()">Voltar</v-btn>
                    <v-btn text dark :disabled="desativarAvancar" @click="proximaEtapa()">{{textoAvancar}}</v-btn>
                    <v-btn text dark @click=fechar()>Fechar</v-btn>
			    </v-toolbar-items>
            </v-toolbar>
            
            <v-card-text>
            <v-container>
                <v-stepper v-model="etapa" vertical>
                    <v-stepper-step :complete="etapa > 1" step="1">
                        <h2>Preencha os dados gerais</h2>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-card>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="3">
                                                    <v-text-field dense label="Quem será atendido" v-model="atendimento.atendido.nome" readonly outlined></v-text-field> 
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field readonly dense label="Responsavel" append-icon="mdi-magnify" @click:append="showResponsavel" v-model="atendimento.responsavel.nome" outlined></v-text-field>
                                                    <v-menu v-model="buscandoResponsavel"
                                                            :position-x="x"
                                                            :position-y="y"
                                                            absolute
                                                            offset-x
                                                            :close-on-content-click="closeOnClick"
                                                            min-width="300"
                                                            >
                                                        <v-card>
                                                            <v-container>
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <v-text-field dense label="Pesquisar por" v-model="nomePesquisa"></v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <v-data-table locale="pt-BR" dense fixed-header class="table-item" :items="iniciados" :headers="fields" :items-per-page="15">
                                                                            <template v-slot:item.action="{ item }">
                                                                                <v-btn icon class="mx-1" color="primary" @click="selecionar(item)">
                                                                                    <v-icon>mdi-check</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                        </v-data-table>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field dense label="Acompanhante" readonly append-icon="mdi-magnify" @click:append="showAcompanhante" v-model="atendimento.acompanhante.nome" outlined></v-text-field>
                                                    <v-menu v-model="buscandoAcompanhante"
                                                            :position-x="x"
                                                            :position-y="y"
                                                            absolute
                                                            offset-x
                                                            :close-on-content-click="closeOnClick"
                                                            min-width="300"
                                                            >
                                                        <v-card>
                                                            <v-container>
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <v-text-field dense label="Pesquisar por" v-model="nomePesquisa"></v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <v-data-table locale="pt-BR" dense fixed-header class="table-item" :items="iniciados" :headers="fields" :items-per-page="15">
                                                                            <template v-slot:item.action="{ item }">
                                                                                <v-btn icon class="mx-1" color="primary" @click="selecionarAcompanhante(item)">
                                                                                    <v-icon>mdi-check</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                        </v-data-table>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field dense outlined label="Indicado por" v-model="atendimento.indicacao"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3">
                                                    <v-menu ref="abrirDtAtendimentoPicker" v-model="abrirDtAtendimentoPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field  ref="refDtAtendimento" @focus="abrirDtAtendimentoPicker = true" dense label="Data do Atendimento" v-model="dataAtendimentoFormatada" v-on="on" outlined></v-text-field>
                                                        </template>
                                                        <v-date-picker @change="btnChecagem = 'verificar'" locale="pt-br" v-model="dataAtendimento" no-title @input="abrirDtAtendimentoPicker = false"></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-menu ref="hrAtendimento" v-model="hrAtendimento" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field ref="refHrAtendimento" @focus="hrAtendimento = true" dense label="Horário do Atendimento" v-model="horaAtendimento" v-on="on" outlined></v-text-field>
                                                        </template>
                                                        <v-time-picker format="24hr" v-model="horaAtendimento" @input="hrAtendimento = false"></v-time-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-select ref="refLocal" @change="btnChecagem = 'verificar'" :disabled="atendimento.externo" dense item-value="id" item-text="descricao" :items="this.locais" v-model="atendimento.local" label="Local" outlined></v-select>
                                                </v-col>
                                                <v-col cols="3" class="d-flex align-start">
                                                    <v-checkbox v-model="atendimento.externo" class="mt-0" dense label="Atendimento externo"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="" cols="3">
                                                    <v-menu ref="hrInicio" v-model="abrirInicioReserva" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field  @focus="abrirInicioReserva = true" ref="refInicioReserva" :disabled="atendimento.externo" dense label="Inicio reserva" v-model="inicioReserva" v-on="on" outlined></v-text-field>
                                                        </template>
                                                        <v-time-picker format="24hr" @change="btnChecagem = 'verificar'" v-model="inicioReserva" @input="abrirInicioReserva = false"></v-time-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col class="" cols="3">
                                                    <v-menu ref="hrFim" v-model="abrirFimReserva" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field  @focus="abrirFimReserva = true" ref="refFimReserva" :disabled="atendimento.externo" dense label="Fim reserva" v-model="fimReserva" v-on="on" outlined></v-text-field>
                                                        </template>
                                                        <v-time-picker format="24hr" @change="btnChecagem = 'verificar'" v-model="fimReserva" @input="abrirFimReserva = false"></v-time-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-btn v-if="btnChecagem == 'verificar'" :disabled="atendimento.externo" dense color="primary" @click="checarDisponibilidade()">Verificar Disponibilidade</v-btn>
                                                    <v-btn v-else-if="btnChecagem == 'disponivel'" :disabled="atendimento.externo" dense color="success"><v-icon>mdi-check</v-icon></v-btn>
                                                    <v-btn v-else-if="btnChecagem == 'indisponivel'" :disabled="atendimento.externo" dense color="error"><v-icon>mdi-alert-circle</v-icon></v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-stepper-content>
                    
                    <!-- etapa 2 -->
                    <v-stepper-step :complete="etapa > 2" step="2">
                        <h2>Informe o motivo do atendimento</h2>
                    </v-stepper-step>
                    <v-stepper-content step="2">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-card>
                                        <v-container>
                                            <v-row>
                                                <v-col class="" cols="12">
                                                    <v-select item-value="id" item-text="descricao" :items="this.tiposAtendimento" v-model="atendimento.tipoAtendimento" label="Tipo Atendimento" outlined></v-select>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-card flat outlined>
                                                        <v-card-title>
                                                            <h4>Campo de atendimento</h4>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-item-group  multiple>
                                                                <v-checkbox v-model="atendimento.campoAtendimento" v-for="(item) in camposAtendimento" :key="item.value" :value="item.value" :label="item.text" ></v-checkbox>
                                                            </v-item-group>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-card flat outlined>
                                                        <v-card-title>
                                                            <h4>Motivo do atendimento</h4>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-item-group  multiple>
                                                                <v-checkbox v-model="atendimento.motivo" v-for="(item) in motivos" :key="item.id" :value="item.id" :label="item.descricao" ></v-checkbox>
                                                            </v-item-group>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>                                                
                                                <v-col cols="12">
                                                    <v-textarea outlined label="Comentario" v-model="atendimento.comentario"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-stepper-content>

                    <!-- etapa 3 -->
                    <v-stepper-step :complete="etapa > 3" step="3">
                        <h2>Confirmar atendimento</h2>
                    </v-stepper-step>
                    <v-stepper-content step="3">
                        <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-card ref="etapa3">
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col offset="1" cols="4">
                                                    <v-simple-table dense class="text-center">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-center">Campo</th>
                                                                    <th class="text-center">Valor</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Pessoa a ser atendida</td>
                                                                    <td>{{atendimento.atendido.nome}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Responsavel pelo atendimento</td>
                                                                    <td>{{atendimento.responsavel.nome}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Acompanhante do atendimento</td>
                                                                    <td>{{atendimento.acompanhante.nome}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Data do atendimento</td>
                                                                    <td>{{atendimento.dataAtendimento.toLocaleDateString()}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Horário do atendimento</td>
                                                                    <td>{{atendimento.horaAtendimento.toLocaleTimeString()}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Quem indicou</td>
                                                                    <td>{{atendimento.indicacao}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-col>
                                                <v-col offset="1" cols="4">
                                                    <v-simple-table dense class="text-center">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-center">Campo</th>
                                                                    <th class="text-center">Valor</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Campo de atendimento</td>
                                                                    <td>{{mostrarNomeCampoAtendimento(atendimento.campoAtendimento)}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Motivo de atendimento</td>
                                                                    <td>{{mostrarNomeMotivoAtendimento(atendimento.motivo)}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Tipo de atendimento</td>
                                                                    <td>{{mostrarNomeTiposAtendimento(atendimento.tipoAtendimento)}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Comentario</td>
                                                                    <td>{{atendimento.comentario}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        </v-container>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-checkbox v-if="atendimento.etapa == 3" v-model="cbEtapa3" label="Dados Confirmados"></v-checkbox>
                            </v-col>
                            <v-col v-if="atendimento.etapa < 4" cols="12" class="text-center">
                                <v-sheet height="34" elevation="2" dark class="text-center pt-2 mb-1" color="primary"><h2>Ao salvar o atendimento, nenhuma informação das etapas anteriores poderá ser alterada.</h2></v-sheet>
                                <v-sheet height="34" elevation="2" dark class="text-center pt-2 mt-1" color="primary"><h2>Será enviado um email para o atendido no endereço "{{atendimento.atendido.email}}", para que o mesmo confirme o atendimento.</h2></v-sheet>
                            </v-col>
                            <v-col v-else cols="12" class="text-center">
                                <v-sheet height="34" elevation="2" dark class="text-center pt-2" color="primary"><h2>Atendimento já salvo, nenhuma informação pode ser alterada.</h2></v-sheet>
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <!-- etapa 4 -->
                    <v-stepper-step :complete="etapa > 4" step="4">
                        <h2>Aguardando que {{atendimento.atendido.nome}} confirme o atendimento.</h2>
                    </v-stepper-step>
                    <v-stepper-content step="4">
                        <v-row v-if="atendimento.etapa > 4">
                            <v-col cols="12">
                                <v-card>
                                    <v-card-text>
                                        <h3 v-if="confirmacao.usuarioConfirmacao">O Atendimento foi {{confirmacao.confirmado}} no dia {{confirmacao.data}} as {{confirmacao.hora}} por {{confirmacao.nome}}</h3>
                                        <h3 v-else>O Atendimento foi {{confirmacao.confirmado}} no dia {{confirmacao.data}} as {{confirmacao.hora}} por {{atendimento.atendido.nome}}</h3>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="atendimento.status == 5 || atendimento.status == 4">
                            <v-col cols="12">
                                <v-card>
                                    <v-card-text>
                                        <h3 v-if="atendimento.usuarioCancelamento != null">O Atendimento foi cancelado no dia {{mostrarData(atendimento.dataCancelamento)}} por {{atendimento.usuarioCancelamento}}</h3>
                                        <h3 v-else>O Atendimento foi cancelado no dia {{mostrarData(atendimento.dataCancelamento)}} por {{atendimento.atendido.nome}}</h3>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="8">
                                <v-btn :disabled="desativarBtnReenviarEmail || !this.verificaAcesso(this.acessos.REENVIAREMAILATENDIMENTO)" color="primary" class="mx-2" @click="enviarEmail(atendimento.atendido)">Reenviar email</v-btn>
                                <v-btn :disabled="desativarBtnCancelar || !this.verificaAcesso(this.acessos.CANCELARATENDIMENTO)" color="primary" class="mx-2" @click="cancelarAtendimento()">Cancelar atendimento</v-btn>
                                <v-btn :disabled="desativarBtnAprovar || !this.verificaAcesso(this.acessos.APROVARATENDIMENTO)" color="primary" class="mx-2" @click="aprovarAtendimento()">Aprovar atendimento</v-btn>
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <!-- etapa 5 -->

                    <v-stepper-step :complete="etapa > 5" step="5">
                        <h2>Registrar resultados</h2>
                    </v-stepper-step>
                    <v-stepper-content step="5">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-card>
                                        <v-container>
                                            <v-row justify="center">
                                                <v-col cols="8">
                                                    <v-card v-if="atendimento.tipoAtendimento == '4'">
                                                        <v-card-title>
                                                            <h3>Medições</h3>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-container>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Raiz" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.raiz.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.raiz.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Sexual" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.sexual.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.sexual.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Solar" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.solar.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.solar.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Cardiaco" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.cardiaco.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.cardiaco.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Laringeo" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.laringeo.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.laringeo.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Frontal" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.frontal.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.frontal.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Coronario" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.coronario.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.coronario.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <v-text-field readonly label="Chackra" value="Kundalini" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.kundalini.antes" label="Antes" outlined></v-select>
                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-select dense :items="this.itensMedicao" v-model="atendimento.medicao.kundalini.depois" label="Depois" outlined></v-select>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-textarea outlined auto-grow label="Considerações" v-model="atendimento.consideracoes"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-stepper-content>

                    <!-- etapa 6 -->
                    <v-stepper-step :complete="etapa > 6" step="6">
                        <h2>Revisar resultado</h2>
                    </v-stepper-step>
                    <v-stepper-content step="6">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-card ref="etapa6">
                                        <v-container>
                                            <v-row justify="center">
                                                <v-col cols="6">
                                                    <v-card v-if="atendimento.tipoAtendimento == '4'">
                                                        <v-container>
                                                            <v-row>
                                                                <v-col cols="12">
                                                                    <v-simple-table class="text-center">
                                                                        <template v-slot:default>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th class="text-center">Chackra</th>
                                                                                    <th class="text-center">Antes</th>
                                                                                    <th class="text-center">Depois</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>Raiz</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.raiz.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.raiz.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Sexual</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.sexual.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.sexual.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Solar</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.solar.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.solar.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Cardiaco</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.cardiaco.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.cardiaco.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Laringeo</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.laringeo.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.laringeo.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Frontal</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.frontal.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.frontal.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Coronario</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.coronario.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.coronario.depois)}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Kundalini</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.kundalini.antes)}}</td>
                                                                                    <td>{{mostrarNomeMedicao(atendimento.medicao.kundalini.depois)}}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </template>
                                                                    </v-simple-table>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-textarea auto-grow  outlined readonly label="Considerações" v-model="atendimento.consideracoes"></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-checkbox v-if="atendimento.etapa == 6" v-model="cbEtapa6" label="Dados Confirmados"></v-checkbox>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-stepper-content>

                    <!-- etapa 7 -->
                    <v-stepper-step :complete="etapa == 7" step="7">
                        <h2>Atendimento finalizado.</h2>
                    </v-stepper-step>
                    <v-stepper-content step="7">
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <h2 v-if="atendimento.status == 5">O Atendimento foi cancelado em {{mostrarData(atendimento.dataCancelamento)}} por {{atendimento.usuarioCancelamento}}</h2>
                                                <h2 v-else>O Atendimento foi finalizado em {{mostrarData(atendimento.dataAtualizacao)}} por {{atendimento.usuarioAtualizacao}}</h2>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">

                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <!-- <v-row justify="center">
                            <v-col cols="12">
                                <v-btn color="primary" class="mx-2" @click="exportarPdf()">Exportar PDF</v-btn>
                            </v-col>
                        </v-row> -->
                    </v-stepper-content>
                </v-stepper>
            </v-container>
            </v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import metodos from '@/mixins/metodos.js'
import axios from 'axios'
import { baseApiUrl, showSuccess, showError} from "@/config/global"
import ACESSOS from '@/Enums/Acessos.js'



export default {
    
    props: ['mostrar', 'registroPessoa', 'registroAtendimento'],
    computed:{
            ...mapState(['listaLocais', 'user']),
        },
    mixins:[metodos],
    data(){
        return{
            acessos: ACESSOS,
            chamarPesquisa: false,
            ultNomePesquisa: null,
            loading: false,
            btnChecagem: 'verificar',
            locais: [],
            confirmacao: {},
            desativarVoltar: true,
            desativarAvancar: false,
            desativarBtnCancelar: false,
            desativarBtnAprovar: false,
            desativarBtnReenviarEmail: false,
            cbEtapa3: false,
            cbEtapa6: false,
            textoAvancar: 'Avançar',
            itensMedicao: [
                {
                    value: 'A',
                    text: 'Anti-horário'
                },
                {
                    value: 'P',
                    text: 'Parado'
                },
                {
                    value: 'H',
                    text: "Horário"
                }
            ],
            camposAtendimento:[
                {
                    value: 'F',
                    text: 'Fisico'
                },
                {
                    value: 'M',
                    text: 'Mental'
                },
                {
                    value: 'E',
                    text: "Espiritual"
                }
            ],
            motivos: [],
            tiposAtendimento: [],
            etapa: 1,
            buscandoResponsavel: false,
            buscandoAcompanhante: false,
            mostrarPesquisaNome: false,
            cor: 'primary',
            ficha: {},
            pessoa: {},
            atendimento: {
                externo: false,
                etapa: 1,
                campoAtendimento: [],
                motivo: [],
                local:{},
                responsavelAtendido:{
                    id: 0,
                    nome: null,
                    email: null
                },
                responsavel: {
                    nome: ''
                },
                acompanhante: {
                    nome: ''
                },
                atendido: {
                    nome: ''
                },
                medicao: {
                    raiz: {
                        antes: '',
                        depois: ''
                    },
                    sexual: {
                        antes: '',
                        depois: ''
                    },
                    solar: {
                        antes: '',
                        depois: ''
                    },
                    cardiaco: {
                        antes: '',
                        depois: ''
                    },
                    laringeo: {
                        antes: '',
                        depois: ''
                    },
                    frontal: {
                        antes: '',
                        depois: ''
                    },
                    coronario: {
                        antes: '',
                        depois: ''
                    },
                    kundalini: {
                        antes: '',
                        depois: ''
                    }
                },
            },
            abrirInicioReserva: false,
            abrirFimReserva: false,
            inicioReserva: '',
            fimReserva: '',
            hrAtendimento: false,
            horaAtendimento: '',
            abrirDtAtendimentoPicker: false,
            dataAtendimento: '',
            dataAtendimentoFormatada: '',
            x: 0,
            y: 0,
            closeOnClick: false,
            nomePesquisa: '',
            iniciados: [],
            fields: [
					{value: 'id_user', text: 'Código', align: 'center'},
					{value: 'nome', text: 'Nome', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
        }
    },
    methods:{
        mostrarNomeCampoAtendimento(campos){
            let campo = []
            campos.forEach((f) => {
                switch(f){
                    case 'F':
                        f = 'Fisico'
                        break
                    case 'M':
                        f = 'Mental'
                        break
                    case 'E':
                        f = 'Espiritual'
                        break
                }
                campo.push(f)
            })
            return campo.join(",")
        },

        mostrarNomeMotivoAtendimento(registros){
            let nomes = []
            registros.forEach(v => {
                let nome = this.motivos.find(e => e.id == v)
                nomes.push(nome.descricao)
            })

            return nomes.join(",")
        },

        mostrarNomeTiposAtendimento(registro){    
            let nome = this.tiposAtendimento.find(e => e.id == registro)
                
            return nome.descricao
        },

        mostrarNomeMedicao(registro){
            let nome = ""
            switch(registro){
                case "A":
                    nome = "Anti-horário"
                    break
                case "P":
                    nome = "Parado"
                    break
                case "H":
                    nome = "Horário"
                    break
            }

            return nome
        },

    
        checarDisponibilidade(){
            if(!this.dataAtendimento){
                showError("Informe a data do atendimento")
                this.$refs.refDtAtendimento.focus()
            }else if(!this.inicioReserva){
                showError("Informe o horário inicio da reserva")
                this.$refs.refInicioReserva.focus()
            }else if(!this.fimReserva){
                showError("Informe o horário fim da reserva")
                this.$refs.refFimReserva.focus()
            }else if(typeof(this.atendimento.local) == "object"){
                showError("Informe o local do atendimento")
                this.$refs.refLocal.activateMenu()
            }else{
                const url = `${baseApiUrl}/reservas/checaReserva.php`
                const obj = {
                    data: this.converterData(this.atendimento.dataAtendimento),
                    hrInicio: this.converterHora(this.inicioReserva),
                    hrFim: this.converterHora(this.fimReserva),
                    local: this.atendimento.local
                }
                
                axios.post(url, obj).then(res => {
                    if(res.data.codigo == '01'){
                        this.btnChecagem = "disponivel"
                    }else{
                        this.btnChecagem = 'indisponivel'
                    }
                })
                
            }
        },

        fechar(){
            this.$emit('fecharAtendimento')
            this.etapa = 1
            this.validaEtapa()
        },

        showResponsavel(e) {
            this.iniciados = [],
            this.nomePesquisa = '',
            this.x = e.clientX
            this.y = e.clientY        
            this.buscandoResponsavel = true
        
        },

        showAcompanhante(e) {
            this.iniciados = [],
            this.nomePesquisa = '',
            this.x = e.clientX
            this.y = e.clientY        
            this.buscandoAcompanhante = true
        
        },

        salvar(){
            
        },

        buscaResponsavel(n){
            
            const url = `${baseApiUrl}/iniciados/pesquisa.php?nome=${n}`

            axios.post(url, n).then(res => {
        
                this.iniciados = res.data
            })
        },

        selecionar(responsavel){
            this.atendimento.responsavel = responsavel
            this.buscandoResponsavel = false
            this.responsavel = {}
        },

        selecionarAcompanhante(acompanhante){
            this.atendimento.acompanhante = acompanhante
            this.buscandoAcompanhante = false
            this.acompanhante = {}
        },

        proximaEtapa(){
            switch(this.atendimento.etapa){
                case 1: 
                    if(this.atendimento.externo){
                        if(this.atendimento.atendido && this.atendimento.dataAtendimento && this.atendimento.horaAtendimento && this.atendimento.responsavel && this.atendimento.acompanhante && this.atendimento.indicacao){
                            this.etapa++
                            if(this.etapa > this.atendimento.etapa){
                                this.atendimento.etapa = this.etapa
                            }
                            this.validaEtapa()
                        }
                        else{
                            showError("Todos os campos devem ser preenchidos!")
                        }
                    }else{
                        if(this.atendimento.atendido && this.atendimento.dataAtendimento && this.atendimento.horaAtendimento && this.atendimento.responsavel && this.atendimento.acompanhante && this.atendimento.indicacao){
                            if(this.btnChecagem == "disponivel"){
                                this.etapa++
                                if(this.etapa > this.atendimento.etapa){
                                    this.atendimento.etapa = this.etapa
                                }
                                this.validaEtapa()
                            }else{
                                if(this.btnChecagem == 'indisponivel'){
                                    showError("O local não está disponivel no horário indicado!")
                                }else{
                                    showError("Verifique se o local está disponivel no horário indicado!")
                                }
                            }    
                        }else{
                            showError("Todos os campos devem ser preenchidos!")
                        }
                    }
                    break;
                case 2:

                    if(this.etapa == 1){
                        if(this.atendimento.externo){
                            if(this.atendimento.atendido && this.atendimento.dataAtendimento && this.atendimento.horaAtendimento && this.atendimento.responsavel && this.atendimento.acompanhante && this.atendimento.indicacao){
                                this.etapa++
                                if(this.etapa > this.atendimento.etapa){
                                    this.atendimento.etapa = this.etapa
                                }
                                this.validaEtapa()
                            }
                            else{
                                alert('erro')
                            }
                        }else{
                            if(this.atendimento.atendido && this.atendimento.dataAtendimento && this.atendimento.horaAtendimento && this.atendimento.responsavel && this.atendimento.acompanhante && this.atendimento.indicacao){
                                if(this.btnChecagem == "disponivel"){
                                    this.etapa++
                                    if(this.etapa > this.atendimento.etapa){
                                        this.atendimento.etapa = this.etapa
                                    }
                                    this.validaEtapa()
                                }else{
                                    if(this.btnChecagem == 'indisponivel'){
                                        showError("O local não está disponivel no horário indicado!")
                                    }else{
                                        showError("Verifique se o local está disponivel no horário indicado!")
                                    }
                                }    
                            }else{
                                showError("Todos os campos devem ser preenchidos!")
                            }
                        }
                    }else{
                        if(this.atendimento.campoAtendimento && this.atendimento.motivo && this.atendimento.tipoAtendimento){
                            this.etapa++        
                            this.atendimento.etapa = this.etapa
                            this.validaEtapa()
                        }else{
                            alert('erro')
                        }
                    }
                    break;

                case 3:
                    if(this.etapa == 1){
                        if(this.atendimento.atendido && this.atendimento.dataAtendimento && this.atendimento.horaAtendimento && this.atendimento.local && this.atendimento.responsavel && this.atendimento.acompanhante && this.atendimento.indicacao){
                            this.etapa++
                            this.validaEtapa()
                        }else{
                            alert('erro')
                        }
                    }else if(this.etapa == 2){
                        if(this.atendimento.campoAtendimento && this.atendimento.motivo && this.atendimento.tipoAtendimento){
                            this.etapa++        
                            this.atendimento.etapa = this.etapa
                            this.validaEtapa()
                        }else{
                            alert('erro')
                        }
                    }else{
                        if(this.cbEtapa3){
                            this.salvarAtendimento()
                        }else{
                            alert('Necessário marcar a caixa "Dados Confirmados"')
                        }
                    }
                    break;
                case 4:
                    if(this.etapa < 4){
                        this.etapa++
                        this.validaEtapa()
                    }
                    break;
                case 5:
                    if(this.etapa < 5){
                        this.etapa++
                        this.validaEtapa()
                    }else{
                        if(this.atendimento.tipoAtendimento == "4"){
                            if(this.atendimento.medicao.raiz.antes && this.atendimento.medicao.raiz.depois 
                            && this.atendimento.medicao.sexual.antes && this.atendimento.medicao.sexual.depois
                            && this.atendimento.medicao.solar.antes && this.atendimento.medicao.solar.depois
                            && this.atendimento.medicao.cardiaco.antes && this.atendimento.medicao.cardiaco.depois
                            && this.atendimento.medicao.laringeo.antes && this.atendimento.medicao.laringeo.depois
                            && this.atendimento.medicao.frontal.antes && this.atendimento.medicao.frontal.depois
                            && this.atendimento.medicao.coronario.antes && this.atendimento.medicao.coronario.depois
                            && this.atendimento.medicao.kundalini.antes && this.atendimento.medicao.kundalini.depois
                            && this.atendimento.consideracoes){
                                
                                this.etapa++        
                                this.atendimento.etapa = this.etapa
                                this.validaEtapa()

                            }else{
                                alert('erro')
                            }
                        }else{
                            this.etapa++        
                            this.atendimento.etapa = this.etapa
                            this.validaEtapa()
                        }
                    }
                    break;
                case 6:
                    if(this.etapa == 6){
                        if(this.cbEtapa6){
                            if(this.atendimento.consideracoes){
                                this.atualizarAtendimento(true)
                            }else{
                                showError("Campo considerações precisa ser preenchido")
                            }
                        }else{
                            showError('Necessário marcar a caixa "Dados Confirmados"')
                        }
                    }else{
                        this.etapa++
                        this.validaEtapa()
                    }
                    break;
                case 7:
                    if(this.etapa < 7){
                        this.etapa++
                        this.validaEtapa()
                    }
                    break;

            }

            
        },

        salvarAtendimento(){
            //tem um bug, apos salvar e dar erro, o botao fica habilitado e nao salvar novamente, mas passa etapa
            const url = `${baseApiUrl}/Atendimentos/Fichas/insert.php`
            this.atendimento.etapa++
            let dados = this.atendimento
            dados.user = this.user.user

            axios.post(url, dados )
            .then(res => {
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    this.atendimento.id = res.data.id
                    this.etapa++        
                    this.validaEtapa()
                    this.enviarEmail()
                    
                    
                }else{
                    this.atendimento.etapa = this.etapa
                    showError(res.data.mensagem)
                }
            })

        },

        atualizarAtendimento(finaliza){
            const url = `${baseApiUrl}/Atendimentos/Fichas/update.php`
            let dados = this.atendimento
            dados.user = this.user.user
            axios.post(url, dados )
            .then(res => {
                
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    this.atendimento.dataAtualizacao = res.data.dataAtualizacao
                    this.atendimento.usuarioCancelamento = this.user.dados.nome
                    this.atendimento.usuarioAtualizacao = this.user.dados.nome
                    this.etapa++
                    this.validaEtapa()
                    if(finaliza){
                        this.$emit('finalizarAtendimento', this.atendimento)
                    }else{
                        this.$emit('atualizarAtendimento', this.atendimento)
                    }
                    
                }else{
                    this.atendimento.etapa = this.etapa
                    showError(res.data.mensagem)
                }
            })

        },

        enviarEmail(){
            const urlEmail = `${baseApiUrl}/emails/novoAtendimento.php`
            this.loading = true
            this.desativarBotao = true
            axios.post(urlEmail, {id: this.atendimento.id})
            .then(res => {
                if(res.data.codigo == "01"){
                    showSuccess(res.data.mensagem)
                    this.desativarBotao = false
                    this.loading = false
                }else{
                    showError(res.data.mensagem)
                    this.desativarBotao = false
                    this.loading = false
                }
            })
        },

        aprovarAtendimento(){

            
            const url = `${baseApiUrl}/Atendimentos/Fichas/aprovarSemEmail.php`
            let dados = {
                timestamp: new Date().getTime(),
                user: this.user.user,
                idAtendimento: this.atendimento.id
            }
            axios.post(url, dados)
            .then(res =>{

                if(res.data.codigo == "01"){
                    showSuccess(res.data.mensagem)
                    this.etapa++
                    this.validaEtapa()
                    this.atendimento.etapa = this.etapa
                    this.atendimento.nome_status = res.data.nomeStatus
                    this.$emit('atualizarAtendimento', this.atendimento)
                    this.fechar()
                }else{
                    showError(res.data.mensagem)
                }
            })
        },

        cancelarAtendimento(){
            const url = `${baseApiUrl}/Atendimentos/Fichas/cancelar.php`
            let dados = {
                id: this.atendimento.id,
                user: this.user.user
            }
            axios.post(url, dados )
            .then(res => {
                
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    this.atendimento.status = 5
                    this.atendimento.dataCancelamento = res.data.dataCancelamento
                    this.atendimento.usuarioCancelamento = this.user.dados.nome
                    this.atendimento.nome_status = res.data.nomeStatus
                    this.$emit('atualizarAtendimento', this.atendimento)
                    this.validaEtapa()
                    //this.enviarEmail(this.atendimento.atendido)
                }else{
                    //this.atendimento.etapa = this.etapa
                    showError(res.data.mensagem)
                }
            })  
        },

        voltarEtapa(){
            this.etapa--
            this.validaEtapa()
        },

        buscaDados(){
            axios.all([
				axios.get(`${baseApiUrl}/Cadastros/tiposAtendimento/read.php`),
                axios.get(`${baseApiUrl}/Cadastros/motivosAtendimento/read.php`)
            ]).then(axios.spread((tiposRes, motivosRes) => {
                if(motivosRes.data.codigo == "01"){
					this.motivos = motivosRes.data.dados
                    }
                    
                if(tiposRes.data.codigo == "01"){
                    this.tiposAtendimento = tiposRes.data.dados
                }

                
                //this.etapa = this.atendimento.etapa ? this.atendimento.etapa : 1
                this.validaEtapa()

            }))
        },

        async buscaConfirmacao(){
            await axios.get(`${baseApiUrl}/Atendimentos/Fichas/buscaConfirmacao.php?id=${this.atendimento.id}`)
            .then(res => {
                
                if(res.data.codigo == "01"){
                    
                    this.confirmacao = res.data.confirmacao
                    // (c => {
                    //     return {
                    //         confirmado: c.confirmado == '1' ? 'confirmado' : 'recusado',
                    //         data: new Date(c.timestamp).toLocaleDateString('pt-Br')
                    //     }
                    // })
                }
                this.confirmacao.confirmado = this.confirmacao.confirmado == '1' ? 'confirmado' : 'cancelado'
                this.confirmacao.data = new Date(parseInt(this.confirmacao.timestamp)).toLocaleDateString('pt-Br')
                this.confirmacao.hora = new Date(parseInt(this.confirmacao.timestamp)).toLocaleTimeString('pt-Br')
            })
        },

        validaEtapa(){
            switch(this.etapa){
                case 1:
                    this.desativarVoltar = true
                    this.desativarAvancar = false
                    this.textoAvancar = 'Avançar'
                    break;
                case 2:
                    this.desativarVoltar = false
                    this.textoAvancar = 'Avançar'
                    this.desativarAvancar = false
                    break;
                case 3:
                    if(this.atendimento.etapa < 4){
                        this.textoAvancar = 'Salvar'
                        this.cbEtapa3 = false
                        this.desativarAvancar = true
                    }else{
                        this.textoAvancar = 'Avançar'
                        this.desativarAvancar = false
                        this.desativarVoltar = true
                    }
                    break;
                case 4:
                    this.desativarVoltar = false
                    if(this.atendimento.etapa == 4){
                        this.desativarAvancar = true
                    }
                   
                    if(this.atendimento.etapa > 4 || this.atendimento.status == '5' || this.atendimento.status == '4'){
                        this.desativarBtnCancelar = true
                        this.desativarBtnAprovar = true
                        this.desativarBtnReenviarEmail = true
                    }else{
                        this.desativarBtnCancelar = false
                        this.desativarBtnAprovar = false
                        this.desativarBtnReenviarEmail = false
                    }

                    break;
                case 5:
                    this.textoAvancar = 'Avançar'
                    this.desativarVoltar = false
                    this.desativarAvancar = false
                    break;
                case 6:
                    this.textoAvancar = 'Concluir'
                    this.desativarAvancar = true
                    this.desativarVoltar = false
                    this.cbEtapa6 = false
                    break;
                case 7:
                    this.desativarVoltar = true
                    this.desativarAvancar = true
                    this.$emit('finalizarAtendimento')
                    break;
            }
        }
    },

    created(){
        
    },

    watch:{
        dataAtendimento(){
				this.dataAtendimentoFormatada = this.formataDateBr(this.dataAtendimento)
				this.atendimento.dataAtendimento = this.converterData(this.dataAtendimento)
        },
        horaAtendimento(){
                this.atendimento.horaAtendimento = this.converterHora(this.horaAtendimento)
                
        },

        inicioReserva(){
            this.atendimento.inicioReserva = this.converterHora(this.inicioReserva)
        },

        fimReserva(){
            this.atendimento.fimReserva = this.converterHora(this.fimReserva)
        },

        async mostrar(val){
            if(val){
                this.locais = this.listaLocais
                await this.buscaDados()

                if(this.registroAtendimento){
                    
                    this.etapa = parseInt(this.registroAtendimento.etapa)
                    this.atendimento.id = parseInt(this.registroAtendimento.id)
                    this.atendimento.etapa = parseInt(this.registroAtendimento.etapa)
                    this.atendimento.usuarioCancelamento = this.registroAtendimento.usuario_cancelamento
                    this.atendimento.dataCancelamento = this.registroAtendimento.data_cancelamento
                    this.atendimento.usuarioAtualizacao = this.registroAtendimento.usuario_atualizacao
                    this.atendimento.dataAtualizacao = this.registroAtendimento.data_atualizacao
                    this.atendimento.responsavel.id_user = this.registroAtendimento.id_responsavel
                    this.atendimento.responsavel.nome = this.registroAtendimento.nome_responsavel
                    this.atendimento.acompanhante.id_user = this.registroAtendimento.id_acompanhante
                    this.atendimento.acompanhante.nome = this.registroAtendimento.nome_acompanhante
                    this.atendimento.atendido.id_user = this.registroAtendimento.id_atendido
                    this.atendimento.atendido.nome = this.registroAtendimento.nome_atendido
                    this.atendimento.atendido.email = this.registroAtendimento.email_atendido
                    this.atendimento.medicao.raiz.antes = this.registroAtendimento.raiz_antes
                    this.atendimento.medicao.raiz.depois = this.registroAtendimento.raiz_depois
                    this.atendimento.medicao.sexual.antes = this.registroAtendimento.sexual_antes
                    this.atendimento.medicao.sexual.depois = this.registroAtendimento.sexual_depois
                    this.atendimento.medicao.solar.antes = this.registroAtendimento.solar_antes
                    this.atendimento.medicao.solar.depois = this.registroAtendimento.solar_depois
                    this.atendimento.medicao.cardiaco.antes = this.registroAtendimento.cardiaco_antes
                    this.atendimento.medicao.cardiaco.depois = this.registroAtendimento.cardiaco_depois
                    this.atendimento.medicao.laringeo.antes = this.registroAtendimento.laringeo_antes
                    this.atendimento.medicao.laringeo.depois = this.registroAtendimento.laringeo_depois
                    this.atendimento.medicao.frontal.antes = this.registroAtendimento.frontal_antes
                    this.atendimento.medicao.frontal.depois = this.registroAtendimento.frontal_depois
                    this.atendimento.medicao.coronario.antes = this.registroAtendimento.coronario_antes
                    this.atendimento.medicao.coronario.depois = this.registroAtendimento.coronario_depois
                    this.atendimento.medicao.kundalini.antes = this.registroAtendimento.kundalini_antes
                    this.atendimento.medicao.kundalini.depois = this.registroAtendimento.kundalini_depois
                    this.atendimento.responsavelAtendido.id = this.registroAtendimento.id_responsavel_atendido
                    this.atendimento.responsavelAtendido.nome = this.registroAtendimento.nome_responsavel_atendido
                    this.atendimento.responsavelAtendido.email = this.registroAtendimento.email_responsavel_atendido
                    this.atendimento.status = this.registroAtendimento.status_atendimento
                    this.atendimento.nomeStatus = this.registroAtendimento.nome_status
                    this.atendimento.local = this.registroAtendimento.id_local
                    this.atendimento.indicacao = this.registroAtendimento.indicacao
                    this.atendimento.campoAtendimento = this.registroAtendimento.camposAtendimento
                    this.atendimento.motivo = this.registroAtendimento.motivos
                    this.atendimento.tipoAtendimento = this.registroAtendimento.tipo_atendimento
                    this.atendimento.comentario = this.registroAtendimento.comentario
                    this.atendimento.consideracoes = this.registroAtendimento.consideracoes
                    this.dataAtendimento = this.registroAtendimento.data_atendimento
                    this.horaAtendimento = this.registroAtendimento.hora_atendimento
                    
                    this.validaEtapa()
                    
                    if(this.atendimento.etapa > 4){
                        this.buscaConfirmacao()
                    }
                }else{
                    this.atendimento.atendido = this.registroPessoa
                }
            }
        },

        nomePesquisa(val){
            // this.chamarPesquisa = false
            // let dt = this.ultNomePesquisa
            // this.ultNomePesquisa = new Date().getTime()
            // setTimeout(()=>{

            // },1000)
            // if(this.ultNomePesquisa == null){
            //     this.ultNomePesquisa = new Date().getTime()
            // }
            
            
            // this.ultNomePesquisa = new Date().getTime()
            
            //     if((this.ultNomePesquisa - dt) > 1000){
            //         pesquisar = true
            //         setTimeout(()=>{
            //             if(pesquisar){
            
            //             }
            //         },1000)
            //     }else{
            //         pesquisar = false
            //     }
            
            this.buscaResponsavel(val)
        },

        cbEtapa3(val){
            this.desativarAvancar = !val
        },

        cbEtapa6(val){
            this.desativarAvancar = !val
        },
    }
}
</script>

<style scoped>

</style>